module.exports = __webpack_public_path__ + "img/5.17d46f38.png";